import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useAuth } from '@/auth/store';

/**
 * Says so when the server ends this device's session while the app is open (TW-2), rather than letting sync go quiet.
 * It stays until dismissed: signing out is not an event to miss, and nothing on the device was lost.
 */
export function SessionLostNotice() {
  const lost = useAuth((s) => s.sessionLost);
  const navigate = useNavigate();
  useEffect(() => {
    if (!lost) return;
    toast('Signed out on this device', {
      description: 'Your sign-in ended, so syncing stopped. Everything is still here and uploads when you sign in again.',
      duration: Infinity, action: { label: 'Sign in', onClick: () => navigate('/auth') },
    });
    useAuth.setState({ sessionLost: false });
  }, [lost, navigate]);
  return null;
}
